import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import BuildingForm from "../../components/Building/BuildingForm";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";

const BuildingEdit = ({classes, building, personnel, management}) => {

    let action = building.id ? 'edit' : 'add';
    action += !building.parent_id ? '' : '_house';

    return (
        <Layout>
            <Toolbar
                disableGutters
                title={i18n.get('building.' + action)}
            />
            <Card>
                <CardContent>
                    <BuildingForm
                        values={{...building, personnel: personnel, management: management } || {}}
                    />
                </CardContent>
            </Card>
        </Layout>
    )
};

export default BuildingEdit;
